import { useEffect } from "react";

// Scroll-triggered staggered section reveals (design refresh, Jun 2026).
// Only sections still below the fold at mount get the pending state, so the
// hero and above-fold content paint instantly. Respects reduced motion.
export function useScrollReveal(selector = "section.fade-up") {
  useEffect(() => {
    if (
      typeof IntersectionObserver === "undefined" ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return undefined;
    const els = Array.from(document.querySelectorAll(selector)).filter(
      (el) => el.getBoundingClientRect().top > window.innerHeight * 0.9
    );
    if (!els.length) return undefined;
    els.forEach((el) => el.classList.add("reveal-pending"));
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-in");
            entry.target.classList.remove("reveal-pending");
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -6% 0px", threshold: 0.04 }
    );
    els.forEach((el) => obs.observe(el));
    return () => {
      obs.disconnect();
      els.forEach((el) => el.classList.remove("reveal-pending"));
    };
  }, [selector]);
}
